import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
    try {
        const resp = await new Client(options)[options.method]();
        return resp;
    } catch (error) {
        throw error;
    }
};

async function createEOSRewardConfig(params: any) {
    console.log('params:', params)
    return executeRequest({
        path: "/eos-reward-config/create",
        payload: params,
        method: "post",
    });
}

async function updateEOSRewardConfig(params: any, configId: any) {
    return executeRequest({
        path: `/eos-reward-config/update/`,
        payload: { _id: configId, ...params },
        method: "post",
    });
}

async function getEOSRewardConfigs(params: any) {
    // let payload = {
    //     pageNo: params?.pageNo || 1,
    //     pageSize: params?.pageSize || 10,
    //     sortDirection: params?.sortDirection || -1,
    //     sortBy: params?.sortBy || "tier",
    //     search: params?.search ?? "",
    // };

    // if (params?.skipPagination) payload["skipPagination"] = true;

    // const urlParams = new URLSearchParams(payload).toString();

    return executeRequest({
        path: `/eos-reward-config/list`,
        method: "post",
    });
}

async function getEOSRewardConfigInfo(eosRewardConfigId: any) {
    if (!eosRewardConfigId) throw new Error("No eosRewardConfigId provided");

    return executeRequest({
        path: `/eos-reward-config/info/`,
        payload: { eosRewardConfigId },
        method: "post",
    });
}

export async function deleteEOSRewardConfig(eosRewardConfigId: any) {
    if (!eosRewardConfigId) throw new Error("No eosRewardConfigId provided");

    return executeRequest({
        path: `/eos-reward-config/delete/`,
        payload: { eosRewardConfigId },
        method: "post",
    });
}

export async function getEOSList() {
    return executeRequest({
        path: `/annual-reset/list`,
        method: "get"
    });
}

// Note: be careful with this function, it is only used in the InitiateEOS.jsx file, and should not be used in any other places
export async function initiateReqEOS(resetId = null) {
    return executeRequest({
        path: `/annual-reset/init`,
        method: "post",
        payload: { resetId }
    });
}

export { createEOSRewardConfig, updateEOSRewardConfig, getEOSRewardConfigs, getEOSRewardConfigInfo };